import { Vue } from 'vue-property-decorator';

export default {
  handleErrors(context: Vue, error: any, statusCode: number = 0): void {
    const errorCode = statusCode ? statusCode : error.status;

    if (errorCode == 400 || errorCode == 503) {
      const errorMessage = error != null && error.data.ErrorMessages != null && error.data.ErrorMessages.length ?
        error.data.ErrorMessages[0].ErrorMessage :
        null;

      if (errorMessage == null) {
        context.$router.push({ name: 'BadRequestError' });
        return;
      }

      context.$router.push({ name: 'BadRequestError', query: { 'message': errorMessage } });
      return;
    }
    else if (errorCode == 500) {
      context.$router.push({ name: 'InternalError' });
      return;
    }
    else if (errorCode == 404) {
      context.$router.push({ name: 'NotFoundError' });
      return;
    }

    context.$router.push({ name: 'Error' });
  }
}